// extracted by mini-css-extract-plugin
export default {"target__container":"styles_target__container__J9NFJ"};